// extracted by mini-css-extract-plugin
module.exports = {"navigationSpacer":"MyLayout_navigationSpacer__kUsEz","ribbonActive":"MyLayout_ribbonActive__hs1Cy","blurContainer":"MyLayout_blurContainer__9ZUBt","blur":"MyLayout_blur__BLGtY"};